import React from 'react';

const SinglePropertyMap = ({ direction }) => {
  

    if (!direction || Object.keys(direction).length === 0) {
        return <p>Property details not available</p>;
    }

    const { latitude, longitude } = direction;
    const mapSrc = `https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d135905.11693909427!2d${longitude}!3d${latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1727094281524!5m2!1sen!2s`;

    return (
        <div>
            <div className="wg-property single-property-map">
                <div className="wg-title text-11 fw-6 text-color-heading">Get Direction</div>
                <iframe
                    className="map"
                    src={mapSrc}
                    title="Property Location Map"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>

                {/* <div className="info-map">
                    <ul className="box-left">
                        <li><span className="label fw-6">Address</span> <div className="text">{Address}</div></li>
                        <li><span className="label fw-6">City</span> <div className="text">{City}</div></li>
                        <li><span className="label fw-6">State/County</span> <div className="text">{State}</div></li>
                    </ul>
                    <ul className="box-right">
                        <li><span className="label fw-6">Postal Code</span> <div className="text">{PostalCode}</div></li>
                        <li><span className="label fw-6">Area</span> <div className="text">{Area}</div></li>
                        <li><span className="label fw-6">Country</span> <div className="text">{Country}</div></li>
                    </ul>
                </div> */}
            </div>
        </div>
    );
};

export default SinglePropertyMap;
